export const VALIDATE_URL = 'VALIDATE_URL';
export const VALIDATE_URL_SUCCESS = 'VALIDATE_URL_SUCCESS';
export const VALIDATE_URL_FAILURE = 'VALIDATE_URL_FAILURE';

export const SCOPE_DETAILS = 'SCOPE_DETAILS';
export const SCOPE_DETAILS_SUCCESS = 'SCOPE_DETAILS_SUCCESS';
export const SCOPE_DETAILS_FAILURE = 'SCOPE_DETAILS_FAILURE';

export const AUTHORIZE_USER = 'AUTHORIZE_USER';
export const AUTHORIZE_USER_SUCCESS = 'AUTHORIZE_USER_SUCCESS';
export const AUTHORIZE_USER_FAILURE = 'AUTHORIZE_USER_FAILURE';
